<template>
<div id="container" >
	<div
		class="view" 
		:class="(viewTransitioning(view.index) ? 'transitioning' : '')"
		v-for="(view, i) in activeViews"
		:key="view.id"
	>
		<ViewTemplate 
			v-for="(slide, j) in view.slides" 
			:id="view.id"
			:index="j"
			:viewIndex="view.index"
			:activeView="viewIndex"
			:activeSlide="getSlideIndex(view.index)"
			:template="slide.template"
			:content="slide.content"
			:transitioning="viewTransitioning(i)"
			v-on:clearTransitioning='clearTransitioning'
			:count="view.slides.length"
			:key="slide.id"
			v-on:changeSlide="gotoNextSlide"
		/>
		<div class="button-container" :class="{display: arrowDisplay}">
			<div class="arrow-button prev-button fa fa-angle-left" v-on:click="gotoPrevSlide" :class="{display: arrowDisplay, grey: showGreyArrow}"></div>
			<div class="arrow-button next-button fa fa-angle-right" v-on:click="gotoNextSlide" :class="{display: arrowDisplay, grey: showGreyArrow}"></div>
		</div>
	</div>
</div>
</template>

<script>
	import {disableDefaultScroll, enableDefaultScroll, mobileLayout } from '../util.js';
	import ViewTemplate from '../views/factory';

	export default {
		name: 'views',
		components: {
			ViewTemplate
		},
		props: {
			viewIndex: Number,
			slideIndex: Number,
			viewTransitioning: Function,
			getSlideIndex: Function
		},
		computed: {
			getActiveSlide: function(i) {
				return this.getSlideIndex(i);
			},
			activeViews: function() {
				let _this = this;
				return this.$content.filter(function(view, i){
					let isTransitioning = _this.viewTransitioning(i);
					if( _this.viewIndex == i || isTransitioning){
						return view
					}
				})
			},
			arrowDisplay: function()	{
				let view = this.$content[this.viewIndex];
				return !( (view.id === 'home' && this.slideIndex !== 2) )
			},
			showGreyArrow: function() {
				let id = this.$content[this.viewIndex].id;
				let index = this.slideIndex
				let slide = this.$content[this.viewIndex].slides[this.slideIndex];
				let template = slide.template
				if(
					template === 'fullBgImage' ||
					template === 'borderedTwoColumn' ||
					template === 'bgImageTwoColumn' ||
					(id === 'security' && index === 1)
				){
					return true
				} else {
					return false;
				}

			}
		},
		watch: {
			viewIndex: function() {
				// console.log("ANIMATE IN NEW VIEW");
				// disableDefaultScroll();
				// setTimeout(() => {
				// 	enableDefaultScroll();
				// 	this.$emit('clearTransitioning');
				// }, 2);
			},
			slideIndex: function() {
				// disableDefaultScroll();
				// console.log("ANIMATE IN NEW SLIDE");
				// setTimeout(enableDefaultScroll, 2);
			}
		},
		created () {
			// window.addEventListener("mousewheel", this.handleScroll, false);
			// window.addEventListener("DOMMouseScroll", this.handleScroll, false);
			// window.addEventListener('keyup', this.handleKey, false)
		},
		// destroy () {
		// 	window.removeEventListener("mousewheel", this.handleScroll, false);
		// 	window.removeEventListener("DOMMouseScroll", this.handleScroll, false);
		// 	window.removeEventListener('keyup', this.handleKey, false)
		// },
		methods: {
			// handleKey (e) {
			// 	var key = e.keyCode ? e.keyCode : e.which;
			// 	if(key === 40){
			// 		console.log('next slide')
			// 		this.gotoNextSlide();
			// 	} else if(key === 38) {
			// 		this.gotoPrevSlide();
			// 	}	
			// },
			// handleScroll (event) {
			// 	let e = window.event || event;
			// 	let delta = e.wheelDelta || -e.detail;
			// 	if (delta < -50 || delta > 50) {
			// 		let { $content, viewIndex, slideIndex } = this;
			// 		let dir = -1*(Math.max(-1, Math.min(1, delta)));
			// 		let newSlide = slideIndex + dir;

			// 		this.$emit('changeSlide', newSlide);
			// 	}
			// 	e.preventDefault();
			// },
			// gotoView: function(e, i) {
	  //   		if(this.viewIndex !== i){
	  //   			this.$emit('changeView', i);
	  //   		}
	  //   	},
	    	gotoNextSlide: function() {
	    		this.$emit('changeSlide', this.slideIndex + 1)
	    	},
	    	gotoPrevSlide: function() {
	    		this.$emit('changeSlide', this.slideIndex - 1)
	    	},
	    	clearTransitioning: function() {
	    		this.$emit('clearTransitioning');
	    	},
	    	onSwipe: function(event) {
	    		let dir = (event.direction) == 2 ? 1 : -1
	    		this.$emit('changeSlide', this.slideIndex + dir);
	    	}
		}
	} 
</script>

<style lang="scss">
	@import '../sass/variables';

	// .transitioning{
	// 	.view > div{
	// 		visibility: hidden!important;
	// 		&.active{
	// 			visibility: visible!important;
	// 		}
	// 	}
	// }
	.view{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		&.transitioning{
			z-index: 0;
		}
		.slide{
			z-index: 1;
			opacity: 0;
			@media #{$phoneQuery}{
				overflow-y: auto;
				overflow-x: hidden;
			}
		}
		// z-index: 99;
		.active{
			z-index: 4;
			opacity: 1;
		}

		// .active + .slide{
		// 	z-index: 3;
		// }

		// &.active-0{ .slide-0{ z-index: 4; } }
		// &.active-1{ .slide-1{ z-index: 4; } }
		// &.active-2{ .slide-2{ z-index: 4; } }
		// &.active-3{ .slide-3{ z-index: 4; } }
		// &.active-4{ .slide-4{ z-index: 4; } }
		// &.active-5{ .slide-5{ z-index: 4; } }
		// &.active-6{ .slide-6{ z-index: 4; } }
		// &.active-7{ .slide-7{ z-index: 4; } }
		// &.active-8{ .slide-8{ z-index: 4; } }
		&.active-2 .home-2 + .next-button{
			transform: scale(0);
		}

		&.active-0{
			.home-1, .home-2{
				opacity: 0;
			}
		}

		@media #{$desktopQuery}{
			.sound ~ .footer-menu, .neighbor ~ .footer-menu, .convenience ~ .footer-menu{
				li{
					color: #fff;
					&:before{
						background: #fff;
					}
				}
			}
		}
	}

	#app.transitioning{
		.arrow-button{
			opacity: 0.2;
		}
	}
	.arrow-button{
		transition: opacity 300ms ease-out;
	}
	.next-button{
        width: 40px;
        height: 40px;
        background-image: url('../assets/images/arrow-down-white.png');
        background-size: contain;
        position: fixed;
        bottom: 4%;
        left: 50%;
        z-index: 7;
        cursor: pointer;
        transform: scale(0) translate(-50%, 0);
        transition: transform 400ms ease-out, opacity 300ms ease-out;
        &.grey{
        	background-image: url('../assets/images/arrow-down.png');
        }
        &.display{
        	transform: scale(1) translate(-50%, 0);
        	transition: transform 400ms ease-out 240ms, opacity 300ms ease-out;
        }
        @media #{$phoneQuery}{
        	background: transparent!important;
        }
        @media #{$desktopQuery}{
        	&:before{
        		content: none;
        	}
        }
	}

	@media #{$phoneQuery}{
		.button-container{
			position: fixed;
			bottom: 0;
			width: 100%;
			background: $lightgrey;
			z-index: 10;
			display: flex;
			justify-content: flex-end;
			transform: translate(0, 100%);
			transition: transform 400ms ease-out;
			&.display{
				transform: translate(0, 0);
				transition: transform 400ms ease-out 240ms;
			}
			> div{
				position: relative;
				left: auto;
				right: auto;
				width: 40px;
				height: auto;
				transform: scale(1) translate(0, 0)!important;
				text-align: center;
				// font-weight: 700;
				color: $grey;
				font-size: 6.4vw;
				padding: 4px 0;
			}
		}
	}

	.footer-menu{
		position: absolute;
		bottom: 0%;
		@include vw-units((
          'padding-bottom': 2
        ));
		z-index: 5;
		width: 100%;
		transform: translate(0, 100%);
		transition: transform 400ms ease-out;
		&.display{
			transform: translate(0, 0);
			transition: transform 400ms ease-out 240ms;
		}

		ul{
			margin: 0 auto;
			max-width: 58%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			li{
				font-family: 'Barlow';
				letter-spacing: -0.02em;
				color: $darkblue;
				cursor: pointer;
				position: relative;
				@include vw-pixels((
		          'font-size': 18.5
		        ))
				&:first-child{
					display: none;
				}
				@media #{$desktopQuery}{
					&:before{
						content: '';
						position: absolute;
						width: 100%;
						height: 2px;
						background: $darkblue;
						bottom: -6px;
						left: 0;
						transform: scaleX(0);
						transition: transform 400ms ease-out;
					}
					&.active, &:hover{
						&:before{
							transform: scaleX(1);
						}
					}
				}
				&.active{
					cursor: default;
					@media #{$phoneQuery}{
						font-weight: 700;
					}
				}
			}
		}
		@media #{$phoneQuery}{
			background: $lightgrey;
			padding-bottom: 0;
			ul{
				max-width: 92%;
				flex-wrap: wrap;
				padding: 1.6vw 0;
				li{
					font-size: 3vw;
					flex-basis: 50%;
					align-self: center;
					text-align: center;
					margin: 1.6vw 0;
					&:nth-child(4){
						flex-basis: 100%;
					}
				}
			}
		}
	}
</style>